import axios from 'axios';

export default class GuestlistRepo {
    static getCategoryNames(force) {
        return new Promise((resolve, reject) => {
            if (!force && this.categoryNames) {
                resolve(this.categoryNames);
                return;
            }

            axios.get('/guest_categories')
                .then((res) => {
                    let data = res.data;

                    if (data && data.ok) {
                        this.setCategoryNames(data.categories);
                        resolve(this.categoryNames);
                    }
                })
                .catch((err) => {
                    console.error('Guestlist repo, GET categories, caught error:', err);
                    reject(err);
                });
        });
    }

    static setCategoryNames(categoryNames) {
        this.categoryNames = [];
        this.setDefaults();

        categoryNames.forEach((categoryName) => {
            this.addCategoryName(categoryName);
        });
    }

    static setDefaults() {
        this.addCategoryName("Familie");
        this.addCategoryName("Vrienden");
        this.addCategoryName("Collega's");
        this.addCategoryName("Bekenden");
        this.addCategoryName("Overig");
    }

    static addCategoryName(categoryName) {
        if (!this.categoryNames) {
            this.setCategoryNames([]);
        }

        if (this.categoryNames.indexOf(categoryName) === -1) {
            this.categoryNames.push(categoryName);
        }
    }
}

GuestlistRepo.categoryNames = null;



// WEBPACK FOOTER //
// ./src/Portal/Guestlist/GuestlistRepo.js